(function () {
	'use strict';

	angular.module('dcApp').config([
		'$stateProvider',
		'$urlRouterProvider',
		'$httpProvider',
		function ($stateProvider, $urlRouterProvider, $httpProvider) {
			$stateProvider.state('root', {
				abstract: true,
				resolve: {
					connectedUser: [
						'$q',
						'$timeout',
						'$rootScope',
						async function ($q, $timeout, $rootScope) {
							return $rootScope.fetchConnectedUser();
						},
					],
					noRolesCheck: [
						'$state',
						'$q',
						'$log',
						'$rootScope',
						'connectedUser',
						function ($state, $q, $log, $rootScope, connectedUser) {
							if ($rootScope.userRoles.size === 0) {
								$log.warn('cancelling transition and redirect to 403');
								$state.go('accessDenied');
							} else {
								$q.resolve();
							}
						},
					],
					connectedUserIsAdmin: [
						'$q',
						'$rootScope',
						'noRolesCheck',
						async function ($q, $rootScope, noRolesCheck) {
							return $q.resolve($rootScope.isUserAdmin());
						},
					],
					userHasAccess: [
						'connectedUserIsAdmin',
						'noRolesCheck',
						'$q',
						'$rootScope',
						'$state',
						'$log',
						'$window',
						'CONSOLE_ROLE_NAME',
						'LANG_NAME',
						function (
							connectedUserIsAdmin,
							noRolesCheck,
							$q,
							$rootScope,
							$state,
							$log,
							$window,
							CONSOLE_ROLE_NAME,
							LANG_NAME
						) {
							const selectedLanguage = $rootScope.getSelectedLang();
							const savedLanguage = $window.localStorage.getItem(LANG_NAME);

							if (selectedLanguage !== savedLanguage) {
								$log.debug('sync preferences');
								$window.localStorage.setItem(LANG_NAME, selectedLanguage);
								$window.location.reload();
							}

							if (
								$rootScope.userRoles.size === 1 &&
								$rootScope.userRoles.has(CONSOLE_ROLE_NAME)
							) {
								const publicUrls = ['/data/', '/public/'];
								const isPublicUrl = publicUrls.reduce(
									(acc, curr) => acc || $window.location.href.includes(curr),
									false
								);
								return isPublicUrl ? $q.resolve() : $state.go('accessDenied');
							}
							return $q.resolve();
						},
					],
				},
			});

			$stateProvider.state('logged', {
				abstract: true,
				parent: 'root',
				views: {
					'app@': {
						templateUrl: './src/components/layouts/main-layout.html',
						controller: [
							'$scope',
							'$timeout',
							function ($scope, $timeout) {
								$scope.showSplash = true;

								// Remove the index.html splash (layer 1) — no longer needed
								var htmlSplash = document.getElementById('html-splash');
								if (htmlSplash) {
									htmlSplash.remove();
								}

								// Listen for the Angular Element's dismissed event
								$timeout(function () {
									var el = document.getElementById('angular-splash');
									if (el) {
										el.addEventListener('dismissed', function () {
											$scope.$apply(function () {
												$scope.showSplash = false;
											});
										});
									}
								});
							},
						],
					},
				},
				admin: false,
				access: '*',
				resolve: {
					userIsAdmin: [
						'$q',
						'$rootScope',
						'NgCore',
						'connectedUserIsAdmin',
						function ($q, $rootScope, NgCore, connectedUserIsAdmin) {
							NgCore.setUser($rootScope.account, connectedUserIsAdmin);
							return $q.resolve(connectedUserIsAdmin);
						},
					],
					userId: [
						'$q',
						function ($q) {
							return $q.resolve(undefined);
						},
					],
				},
			});

			function addState(config) {
				const stateConfig = { data: { title: config.title } };
				stateConfig.data.admin = config.admin;

				if (config.access) {
					stateConfig.data.access = config.access;
				}

				if (config.url) {
					stateConfig.url = config.url;
				}

				if (config.extraParams) {
					stateConfig.params = config.extraParams;
				}

				if (config.template) {
					stateConfig.views = {
						'content@logged': {
							template: config.template,
						},
					};
					return $stateProvider.state(config.name, stateConfig);
				}

				if (
					config.parent !== undefined &&
					config.controller &&
					config.templateUrl
				) {
					stateConfig.parent = config.parent;
					stateConfig.views = {
						'content@logged': {
							templateUrl: config.templateUrl,
							controller: config.controller,
							controllerAs: '$ctrl',
						},
					};
					return $stateProvider.state(config.name, stateConfig);
				}

				if (config.views) {
					stateConfig.views = config.views;
					return $stateProvider.state(config.name, stateConfig);
				}
			}

			addState({
				name: 'accessDenied',
				url: '/403',
				parent: 'logged',
				title: 'Accès Refusé',
				templateUrl: './src/components/base/error/403.html',
				controller: 'AccessDeniedController',
				admin: false,
				access: '*',
			});

			addState({
				name: 'notFound',
				url: '/404',
				parent: 'logged',
				title: 'Non trouvé',
				templateUrl: './src/components/base/error/404.html',
				controller: {},
				admin: false,
				access: '*',
			});

			addState({
				name: 'parameters',
				url: '/parameters',
				parent: 'logged',
				title: 'Paramètres',
				templateUrl: './src/components/modules/parameters/parameters.html',
				controller: 'ParametersController',
				admin: true,
				access: 'admin',
			});

			addState({
				name: 'web-services',
				url: '/web-services',
				parent: 'logged',
				title: 'Web Services',
				templateUrl: './src/components/modules/web-services/webServices.html',
				controller: 'WebServiceController',
				admin: true,
				access: '*',
			});

			addState({
				name: 'semanticContext',
				url: '/semantic',
				parent: 'logged',
				title: 'Contexte Sémantique',
				templateUrl:
					'./src/components/modules/semantic-rules/semantic-rules.html',
				controller: 'SemanticRulesController',
				admin: true,
				access: '*',
			});

			$stateProvider.state('new-semanticContext', {
				url: '/semantic/list',
				parent: 'logged',
				data: {
					admin: true,
					access: '*',
				},
				views: {
					'content@logged': {
						template: `<app-semantic-rule-list></app-semantic-rule-list>`,
					},
				},
			});

			addState({
				name: 'tags',
				url: '/tags',
				parent: 'logged',
				title: 'Tags',
				templateUrl: './src/components/modules/tags/tags.html',
				controller: 'TagsController',
				admin: true,
				access: 'member',
			});

			addState({
				name: 'monitoring',
				url: '/monitoring',
				parent: 'logged',
				title: 'Supervision',
				templateUrl: './src/components/modules/monitoring/monitoring.html',
				controller: 'MonitoringController',
				admin: true,
				access: 'admin',
			});

			addState({
				name: 'monitoring-context',
				url: '/monitoring/context/:ctx',
				parent: 'logged',
				title: 'Context supervision',
				templateUrl: './src/components/modules/monitoring/monitoring.html',
				controller: 'MonitoringController',
				admin: true,
				access: 'admin',
			});

			$stateProvider.state('data-catalogue', {
				url: '/data-catalogue',
				parent: 'logged',
				data: {
					admin: true,
					access: '*',
					title: 'Data Catalogue',
				},
				views: {
					'content@logged': {
						templateUrl:
							'./src/components/modules/data-catalog/data-catalogue.html',
						controller: 'DataCatalogueController',
						controllerAs: 'vm',
					},
				},
			});

			$stateProvider.state('orphan-projects', {
				url: '/orphan-projects',
				parent: 'logged',
				data: {
					admin: true,
					access: '*',
					title: 'Orphan projects',
				},
				views: {
					'content@logged': {
						template: `<app-orphan-project-list></app-orphan-project-list>`,
					},
				},
			});

			$stateProvider.state('grouping-tags', {
				url: '/grouping-tags',
				parent: 'logged',
				data: {
					title: 'Grouping Tags',
				},
				views: {
					'content@logged': {
						template:
							'<app-resize-wrapper><app-grouping-tag-list-wrapper></app-grouping-tag-list-wrapper></app-resize-wrapper>',
					},
				},
			});

			$urlRouterProvider.otherwise(function ($injector, $location) {
				var $state = $injector.get('$state');
				$state.go('projects');
			});

			if (!$httpProvider.defaults.headers.get) {
				$httpProvider.defaults.headers.get = {};
			}

			// disable IE ajax request caching
			$httpProvider.defaults.headers.get['If-Modified-Since'] =
				'Mon, 26 Jul 1997 05:00:00 GMT';
			// extra
			$httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
		},
	]);
})();
